import { FC, memo } from 'react'

import { FieldProps, FormConfig, FormInputProps } from 'brief-form'
import { countries } from 'commons/types/dictionaries'
import { determineIssuingStateData } from 'commons/utils'
import { FieldSet, Select } from 'ui/components'
import { TextInput } from 'ui/components/InputV2'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { ContactForm } from '../../../types/contact'

type Props = {
  Field: <Input extends React.ComponentType<FormInputProps<any, any>>>(
    props: FieldProps<Input, ContactForm>
  ) => JSX.Element
  config: FormConfig<ContactForm>
}

export const ContactAddress: FC<Props> = memo((props: Props) => {
  const { Field, config } = props

  return (
    <FieldSet legend="Address Information">
      <FormRow>
        <Col>
          <Field
            name="street"
            label="Street"
            input={TextInput}
            inputProps={{
              'data-qa': 'Street',
              maxLength: 100
            }}
          />
        </Col>
        <Col>
          <Field
            name="state"
            label="State/Province"
            input={Select}
            inputProps={{
              'data-qa': 'State/Province',
              'options-data-qa': 'State/Province',
              data: determineIssuingStateData(config.value.country)
            }}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Field
            name="city"
            label="City"
            input={TextInput}
            inputProps={{
              'data-qa': 'City',
              maxLength: 100
            }}
          />
        </Col>
        <Col>
          <Field
            name="zipCode"
            label="Zip/Postal Code"
            input={TextInput}
            inputProps={{
              'data-qa': 'Zip/Postal Code',
              maxLength: 25
            }}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <Field
            name="country"
            label="Country"
            input={Select}
            inputProps={{
              'data-qa': 'Country',
              'options-data-qa': 'Country',
              data: countries
            }}
          />
        </Col>
      </FormRow>
    </FieldSet>
  )
})
